<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="17" viewBox="0 0 24 17" fill="none">
    <path
      d="M3.4 0C2.49826 0 1.63346 0.358213 0.995837 0.995837C0.358213 1.63346 0 2.49826 0 3.4V5.1H23.8V3.4C23.8 2.49826 23.4418 1.63346 22.8042 0.995837C22.1665 0.358213 21.3017 0 20.4 0H3.4ZM0 13.6V6.8H23.8V13.6C23.8 14.5017 23.4418 15.3665 22.8042 16.0042C22.1665 16.6418 21.3017 17 20.4 17H3.4C2.49826 17 1.63346 16.6418 0.995837 16.0042C0.358213 15.3665 0 14.5017 0 13.6ZM16.15 11.9C15.9246 11.9 15.7084 11.9896 15.549 12.149C15.3896 12.3084 15.3 12.5246 15.3 12.75C15.3 12.9754 15.3896 13.1916 15.549 13.351C15.7084 13.5104 15.9246 13.6 16.15 13.6H19.55C19.7754 13.6 19.9916 13.5104 20.151 13.351C20.3104 13.1916 20.4 12.9754 20.4 12.75C20.4 12.5246 20.3104 12.3084 20.151 12.149C19.9916 11.9896 19.7754 11.9 19.55 11.9H16.15Z"
      fill="#015CA1" />
  </svg>
</template>

<script>
export default {
  name: 'blueWalletIcon',
}
</script>
